import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://40911d6fe23a4568aafa12c8d9873483@o4505273855770624.ingest.us.sentry.io/4505273913573376",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});